import React from "react";

export default function Advantage() {
  return (
    <section className="flex flex-col md:flex-row h-screen w-full overflow-hidden">
      {/* Company Section */}
      <div
        className="group w-full md:w-1/2 h-1/2 md:h-full relative overflow-hidden bg-cover bg-center transition-all duration-500"
        style={{
          backgroundImage:
            "linear-gradient(rgba(212, 212, 212, 1), rgba(0, 180, 216, 0.7))",
        }}
      >
        {/* Background Zoom */}
        <div
          className="absolute inset-0 bg-cover bg-center scale-100 group-hover:scale-105 transition-transform duration-700 ease-in-out z-0"
          style={{
            backgroundImage:
              "linear-gradient(#196f8d, rgba(0, 180, 216, 0.7))",
          }}
        />

        {/* Content */}
        <div className="relative z-10 flex items-center justify-center text-white text-center h-full px-6">
          <div className="relative max-w-md w-full">
            {/* Heading */}
            <h2 className="text-3xl md:text-5xl font-bold transition-all duration-500 group-hover:-translate-y-16">
              For Companies
            </h2>

            {/* Description (absolute, hidden by default) */}
            <p className=" left-0 right-0 top-full opacity-0 group-hover:opacity-100 group-hover:translate-y-4 transition-all duration-700 text-sm md:text-xl text-center">
              What companies can expect from the platform<br /><br />         
            </p>

            {/* Button */}
            <a
              href="/company-charter"
              className="absolute left-1/2 transform -translate-x-1/2 bottom-0 translate-y-12 group-hover:translate-y-28 transition-all duration-700 inline-block px-6 py-3 border border-white text-white font-medium rounded-md hover:bg-white hover:text-blue-500"
            >
              Learn More
            </a>
          </div>
        </div>
      </div>

      {/* Independent Section */}
      <div
        className="group w-full md:w-1/2 h-1/2 md:h-full relative overflow-hidden bg-cover bg-center transition-all duration-500"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0, 21, 106, 1), rgba(227, 227, 227, 1))",
        }}
      >
        {/* Background Zoom */}
        <div
          className="absolute inset-0 bg-cover bg-center scale-100 group-hover:scale-105 transition-transform duration-700 ease-in-out z-0"
          style={{
            backgroundImage:
              "linear-gradient(rgba(1, 12, 94, 1), rgba(0, 88, 221, 0.6))",
          }}
        />

        {/* Content */}
        <div className="relative z-10 flex items-center justify-center text-white text-center h-full px-6">
          <div className="relative max-w-md w-full">
            {/* Heading */}
            <h2 className="text-3xl md:text-5xl font-bold transition-all duration-500 group-hover:-translate-y-16">
              For Independent Directors
            </h2>

            {/* Description (absolute, hidden by default) */}
            <p className=" left-0 right-0 top-full opacity-0 group-hover:opacity-100 group-hover:translate-y-4 transition-all duration-700 text-sm md:text-xl text-center">
               From onboarding through ongoing support. <br /><br />
            </p>

            {/* Button */}
            <a
              href="/charters"
              className="absolute left-1/2 transform -translate-x-1/2 bottom-0 translate-y-12 group-hover:translate-y-28 transition-all duration-700 inline-block px-6 py-3 border border-white text-white font-medium rounded-md hover:bg-white hover:text-teal-600"
            >
              Learn More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
